import React from 'react';
import './pdp-addons.scss';
import HorizontalAddon from './HorizontalAddon';
import VerticalAddon from './VerticalAddon';
import SectionDivider from '../SectionDivider';

const PdpAddons = ({ addons = [], desktop = false }) => {
  const sections = [];
  addons.map((a, index) => {
    const lastIndex = index === addons.length - 1;
    if (a.horizontal) {
      sections.push(
        <HorizontalAddon addon={a} desktop key={`horiz-${a.id}-${index}`} />
      );
    } else {
      sections.push(
        <VerticalAddon addon={a} desktop key={`vertical-${a.id}-${index}`} />
      );
    }
    if (!(desktop && lastIndex))
      sections.push(<SectionDivider key={`divider-${a.id}-${index}`} />);
  });
  return sections;
};

export default PdpAddons;
